import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import { IconButton, InputAdornment, TextField, Checkbox } from '@mui/material';
import logo from '../assets/images/logo.png';
import { IoEye, IoEyeOff } from 'react-icons/io5';

function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const handleLogin = (values) => {
    console.log("Kullanıcı giriş bilgileri:", values);
    // Burada herhangi bir kontrol yok → herkes giriş yapabilir
    navigate("/admin/dashboard");
  };

  return (
    <div className='admin-layout'>
      <div className='authpage-container'>
        <div className='card authcard'>
          <div className="authcard-header">
            <img src={logo} alt='logo' className='authpage-logo' />
            <p className='authpage-text'>Tekrar Hoşgeldiniz!</p>
            <p className='authpage-subtext'>Devam etmek için giriş yapınız</p>
          </div>
          <div className="authcard-form">
            <Formik
              initialValues={{ email: '', password: '', rememberMe: false }}
              onSubmit={handleLogin}
            >
              {({ values, handleChange, handleBlur, touched, errors }) => (
                <Form style={{ width: '100%' }}>
                  <p className="auth-input-label">E-Postanız</p>
                  <Field
                    as={TextField}
                    id='LoginPage_email'
                    name='email'
                    label='Email'
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                    className="muitextfield-auth"
                    variant="outlined"
                    size="small"
                    fullWidth
                  />

                  <p className="auth-input-label">Şifreniz</p>
                  <Field
                    as={TextField}
                    id='LoginPage_password'
                    name='password'
                    label='Şifre'
                    type={showPassword ? 'text' : 'password'}
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.password && Boolean(errors.password)}
                    helperText={touched.password && errors.password}
                    className="muitextfield-auth"
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickShowPassword}
                            edge="end"
                            aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
                          >
                            {showPassword ? <IoEye /> : <IoEyeOff />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />

                  {/* Checkbox ve Şifremi Unuttum */}
                  <div className="auth-form-footer">
                    <div className="checkbox-container">
                      <Field
                        name="rememberMe"
                        type="checkbox"
                        as={Checkbox}
                        color="primary"
                        size="small"
                        id="rememberMe"
                      />
                      <label htmlFor="rememberMe">Beni Hatırla</label>
                    </div>

                    <span className="forgot-password" onClick={() => navigate('/sifremi-unuttum')}>
                      Şifremi Unuttum?
                    </span>
                  </div>

                  {/* Giriş Butonu */}
                  <button type="submit" className="login-btn w-100">
                    Giriş Yap
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
